import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Link } from '@mui/material';

import { Drawer } from 'daaas-ui';

export default function TOCDrawer({ open = false, closeDrawer = null }) {
  const { t } = useTranslation(['faq', 'common']);

  return (
    <Drawer
      id="toc-drawer"
      open={open}
      title={t('onThisPage')}
      footer={false}
      anchor="left"
      toggleDrawer={() => closeDrawer('onThisPageDrawer')}
      variant="persistent"
      closeText={t('common:close')}
    >
      <ul className="bullet__alignment">
        <li>
          <Typography variant="body1">
            <Link
              href="#onThisPage1"
              onClick={() => closeDrawer('onThisPageDrawer')}
            >
              {t('heading1')}
            </Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <Link
              href="#onThisPage2"
              onClick={() => closeDrawer('onThisPageDrawer')}
            >
              {t('box1FourthHeading')}
            </Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <Link
              href="#onThisPage3"
              onClick={() => closeDrawer('onThisPageDrawer')}
            >
              {t('box3FirstHeading')}
            </Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <Link
              href="#onThisPage4"
              onClick={() => closeDrawer('onThisPageDrawer')}
            >
              {t('box4FirstHeading')}
            </Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <Link
              href="#onThisPage5"
              onClick={() => closeDrawer('onThisPageDrawer')}
            >
              {t('box5FirstHeading')}
            </Link>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <Link
              href="#onThisPage6"
              onClick={() => closeDrawer('onThisPageDrawer')}
            >
              {t('box6FirstHeading')}
            </Link>
          </Typography>
        </li>
      </ul>
    </Drawer>
  );
}

TOCDrawer.propTypes = {
  open: PropTypes.bool,
  closeDrawer: PropTypes.func,
};
